import React from 'react';

const privacyPolicyList = [
    'Welcome to Ktebstan (کتێبستان). This privacy policy explains how we handle your information when you use our book reading and audiobook listening application.',
    'Information We Don\'t Collect: Ktebstan is designed with your privacy in mind. We do not collect, store, or share any personal information about our users. We do not require user registration, and we do not track your reading or listening habits.',
    'Content and Copyright: All books and audiobooks available through Ktebstan are either in the public domain or are provided with explicit permission from the authors through their publicly available websites. Authors retain the right to request removal of their content at any time by contacting us through our designated channels.',
    'Device Permissions: Ktebstan only requires basic storage permissions to save books for offline reading and listening. These files are stored locally on your device and are not shared with us or any third parties. You can delete these files at any time through your device\'s storage settings.',
    'Third-Party Services: Our app does not integrate with any third-party analytics or advertising services. When you access external author websites through our app, you will be subject to their respective privacy policies and terms of service.',
    'Changes to Privacy Policy: We may update this privacy policy from time to time. Any changes will be reflected in the app, and continued use of Ktebstan after such changes constitutes acceptance of the updated policy.',
    'Contact Us: If you have any questions about this privacy policy, or if you\'re an author wishing to request content removal, please contact us at [Your Contact Information].'
];

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy">
            <h1>Privacy Policy</h1>
            <div className="policy-content">
                {privacyPolicyList.map((item, index) => (
                    <p key={index}>{item}</p>
                ))}
            </div>
        </div>
    );
};

export default PrivacyPolicy;